import axios from 'axios';

const User = {
    set: (data) => localStorage.setItem('userAuth', JSON.stringify(data))
    ,
    get: () => JSON.parse(localStorage.getItem('userAuth')),

    getPrivilage: () => Object.keys(JSON.parse(localStorage.getItem('userAuth'))) !== 0 ? JSON.parse(localStorage.getItem('userAuth')).privilage : [],

    logtOut: () => new Promise(async (resolve, reject) =>
        axios(
            {
                method: 'get',
                url: `${window._env_.REACT_APP_API_AUTH + "/v1/logout"}`,

            }
        )
            .then((res) => {

                localStorage.setItem('userAuth', JSON.stringify({}))
                resolve(res.data.data)
            }).catch((res) => {

                resolve(res.data.data)
            }
            )
    )
    ,
    IsLogin: () => localStorage.getItem('userAuth') !== null ? (Object.keys(JSON.parse(localStorage.getItem('userAuth'))).length !== 0 ? true : false) : false
    ,
    postLogin: (email, password) =>
        new Promise((resolve, reject) =>
            axios.post(window._env_.REACT_APP_API_AUTH + "/v1/login", { username: email, password: password })
                .then(async (res) => {

                    if (res.data.meta.status == false) {
                        resolve({
                            msg: {
                                password: ["Username and Password Incorrect "]
                            },
                            status: false
                        })
                    } else {

                        const res2 = await User.getData(res.data.data.token)

                        let temp = {}
                        temp['token'] = res.data.data.token
                        temp['privilage'] = res.data.data.privilage
                        temp['user_type'] = res.data.data.user_type
                        temp['privilege_group']=res.data.data.privilege_group
                        temp['info'] = res2

                        User.set(temp)

                        resolve({
                            msg: [],
                            status: true
                        })
                    }
                }).catch((res) => {

                    if (res.response.status == 422) {
                        resolve({
                            msg: res.response.data,
                            status: false
                        })
                    }

                    // if (res.status == 200) {
                    //     if (res.data.meta.status == false) {
                    //         resolve({
                    //             msg: [{
                    //                 password: "Username and Password Incorrect "
                    //             }],
                    //             status: false
                    //         })
                    //     }

                    // }

                }
                )
        ),

    code: () =>
        new Promise(async (resolve, reject) =>
            axios(
                {
                    method: 'post',
                    url: `${window._env_.REACT_APP_API_AUTH + "/v1/request_password_code"}`,
                    data: {
                        email: User.get().info.username ? User.get().info.username : User.get().info.email,

                    }
                }
            )
                .then((res) => {
                    resolve(res.data.data)


                }).catch((res) => {





                }
                )
        ),

    getData: (data) =>
        new Promise((resolve, reject) =>
            axios(
                {
                    method: 'get',
                    url: `${window._env_.REACT_APP_API_AUTH + "/v1/token/data"}`,
                    headers: {
                        Authorization: "Bearer " + data
                    }
                }
            )
                .then((res) => {

                    resolve(res.data.data)
                }).catch((res) => {

                }
                )
        ),

    rstPwd: (data) =>
        new Promise((resolve, reject) =>
            axios(
                {
                    method: 'post',
                    url: `${window._env_.REACT_APP_API_AUTH + "/v1/reset_password"}`,
                    data: data

                }
            )
                .then((res) => {

                  
                    resolve(res.data.meta)
                }).catch((res) => {

                }
                )
        ),

    


}
export default User
